import { render, staticRenderFns } from "./OrderTicketPrinter.vue?vue&type=template&id=210feeb2&"
import script from "./OrderTicketPrinter.vue?vue&type=script&lang=js&"
export * from "./OrderTicketPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports